﻿export class DataRequestFinished {
    static eventName() { return 'DataRequestFinished' }

    eventName = DataRequestFinished.eventName;
}